// extracted by mini-css-extract-plugin
export default {"contentRenderer":"StrapiContentRenderer_contentRenderer__7ULd5","imageContainer":"StrapiContentRenderer_imageContainer__94Vo5"};